const baseUrl = process.env.REACT_APP_BASE_URL;
const token = process.env.REACT_APP_TOKEN;
const paymentBaseUrl = process.env.REACT_APP_HYPERPAY_BASE_URL;

if (!baseUrl) {
  throw new Error("API Url is not provided.");
}
const API_ROUTE = `${baseUrl}`;
const API_TOKEN = token;
const PAYMENT_URL = paymentBaseUrl;
const data = { API_ROUTE, API_TOKEN, PAYMENT_URL };
export default data;
